import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'

import type { Plugin } from '../plugin'
import { State } from '../state'

/**
 * Keeps duplicate-checking UI state in sync with employee field edits before
 * the debounced lookup request is dispatched.
 */
export const updateCheckingOnDuplicateSearchEdit = store.reducers.extra(
  (_feature: Plugin['feature'], plugin: Plugin) =>
    new store.reducers.ExtraReducer({
      on: [plugin.collection.plugins.editingPlugin.feature.actions.edit],
      reduce: (state: State, { data: edit }, globalState) => {
        const employee =
          plugin.collection.plugins.currentEntityPlugin.feature.selectors
            .getEditedEntity()
            .asSelector(globalState)

        if (
          TypeChecker.isFalsish(employee?.name) ||
          TypeChecker.isNullish(employee?.organization)
        ) {
          return State.INITIAL
        }

        return {
          ...state,
          isChecking: true,
        }
      },
    }),
)
